import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn(
    "[supabase] VITE_SUPABASE_URL oder VITE_SUPABASE_ANON_KEY fehlt. " +
      "Kopiere .env.example nach .env und trage deine Supabase-Werte ein.",
  );
}

export const supabase = createClient(url ?? "http://localhost", anonKey ?? "anon", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // PKCE: Magic-Link liefert ?code= als Query-Parameter statt #access_token
    // im Fragment. Query-Parameter überleben den Cloudflare-Access-Login-Umweg,
    // URL-Fragmente nicht — sonst bricht der Login hinter dem Access-Gate.
    flowType: "pkce",
  },
});
